
import request from '@/utils/request.js'
const querystring = require('querystring')

// 批改详情
export function fetchCompositionDetail (payload) {
  return request.get('/hcp/teacherSpace/writingCorrecting/writingDetail/' + payload)
}

// 打回重写
export function requestReWork (payload) {
  return request.post('/hcp/teacherSpace/writingCorrecting/teacherBack', querystring.stringify(payload), {
    headers: { 'content-type': 'application/x-www-form-urlencoded' }
  })
}

// 批改
export function requestCorrect (payload) {
  return request.post('/hcp/teacherSpace/writingCorrecting/teacherCorrect', payload)
}

// 答疑
export function requestAnswerQuestion (payload) {
  return request.post('/hcp/teacherSpace/writingCorrecting/teacherAnswer', payload)
}

// 获取写作老师
export function fetchCorrectTeachers (payload) {
  return request.get('/hcp/teacherSpace/writingCorrecting/getWritingTeacherList', payload)
}


// 分配
export function requestDistribute (payload) {
  return request.post('/hcp/teacherSpace/writingCorrecting/distributorUpdateAssign', querystring.stringify(payload), {
    headers: { 'content-type': 'application/x-www-form-urlencoded' }
    // headers: {'content-type': 'multipart/form-data'}
  })
}

// 获取答疑记录
export function fetchAnswerRecords (payload) {
  return request.get('/hcp/teacherSpace/writingCorrecting/getWritingAnswerRecordList/' + payload)
}

// 获取写作状态数量统计
export function fetchStatusCount (payload) {
  return request.get('/hcp/teacherSpace/writingCorrecting/getStatusStatistics')
}

// 获取答疑记录数量统计
export function fetchRecordsCount (payload) {
  return request.get('/hcp/teacherSpace/writingCorrecting/getAnswerStatistics')
}
// 导出作文
export function handleExportWpord (payload) {
  return request.get('/hcp/teacherSpace/writingCorrecting/exportWord/' + payload)
}
// 获取机构写作自动分配开关
export function getAutoAssignSwitch () {
  return request.get('/hcp/teacherSpace/writingCorrecting/getAutoAssignSwitch')
}
// 修改机构写作自动分配开关
export function updateAutoAssignSwitch (payload) {
  return request.post('/hcp/teacherSpace/writingCorrecting/updateAutoAssignSwitch', querystring.stringify(payload), {
    headers: { 'content-type': 'application/x-www-form-urlencoded' }
    // headers: {'content-type': 'multipart/form-data'}
  })
  // return request.post('/hcp/teacherSpace/writingCorrecting/updateAutoAssignSwitch', payload)
}

export function getLastApprovedInfo(payload) {
  return request.post('/hcp/teacherSpace/writingCorrecting/getLastApprovedInfo', payload)
}


// WEBPACK FOOTER //
// ./src/services/writing.js